const apiFilterProcessor1 = (filter = {}) => {
  const filters = [];

  Object.keys(filter).map((key) => {
    if (filter[key].selectedIdList && filter[key].selectedIdList.length > 0) {
      const filterInput = {
        column: key,
        value: filter[key].selectedIdList.toString(),
      };

      filters.push(filterInput);
    }
  });

  return filters;
};

const apiFilterProcessor = (filter = {}) => {
  const filters = [];
  Object.keys(filter).map((key) => {
    if (filter[key] && filter[key].length > 0) {
      const filterInput = {
        column: key,
        value: filter[key].map(String),
      };
      filters.push(filterInput);
    }
  });

  return filters;
};

const getOffsetFromPageAndLimit = (page, limit) => (page - 1) * limit;

const getOffsetFromPagination = (pagination) => (pagination.page - 1) * pagination.limit;

export {
  apiFilterProcessor, getOffsetFromPageAndLimit, getOffsetFromPagination
};
